import React, { useState, useEffect } from 'react';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import './style.css';
import Input from '../../common/InputField';
import { createCannedMsg } from '../../../store/features/createCannedMsg';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TextArea from 'antd/es/input/TextArea';

function CannedPopup({ cannedMsg, setCannedResponse, isTicketCannedMessage }) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);

  const [activeCanned, setActiveCanned] = useState('Shared');
  const [responseText, setResponseText] = useState(cannedMsg || '');
  const [isPrivate, setIsPrivate] = useState(false);
  const [tag, setTag] = useState('');
  const [loading, setLoading] = useState(false); // ✅ loading state

  useEffect(() => {
    setResponseText(cannedMsg);
  }, [cannedMsg]);

  const handleViewChange = (newView) => {
    setActiveCanned(newView);
    setIsPrivate(newView !== 'Shared');
  };

  const handleCreateCannedMsg = async () => {
    if (loading) return; // Prevent double clicks
    setLoading(true); // ✅ start loading

    try {
      const result = await dispatch(
        createCannedMsg({
          requestHeaders: {
            content: responseText,
            tagName: tag,
            business_id: userData?.response?.user?.business_id,
            is_private: isPrivate,
            in_business: !isPrivate,
          },
        })
      );

      if (result?.payload?.success) {
        toast.success('Canned response saved successfully!');
        setResponseText('');
        setTag('');
        setCannedResponse(false);
      } else {
        toast.error('Some error occurred. Please try again later.');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again later.');
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

  const handleTagChange = (e) => {
    setTag(e.target.value);
  };

  const isSaveDisabled = !responseText.trim() || !tag.trim() || tag.length > 15 || tag === '# Type';

  return (
    <>
      <div className="overlay" />
      <div className="Canned-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Save reply as canned response</p>
          <p className="PopUp-Text02" onClick={() => setCannedResponse(false)}>
            <Close />
          </p>
        </div>

        <div className="ChatAgent-Main-Container">
          <p
            className={`chats-text ${activeCanned === 'Shared' ? 'activeChat' : ''}`}
            onClick={() => handleViewChange('Shared')}
          >
            Shared
          </p>
          <p
            className={`Archive-text ${activeCanned === 'Private' ? 'activeChat' : ''}`}
            onClick={() => handleViewChange('Private')}
          >
            Private
          </p>
        </div>

        <p className="PopUp-Canned-Text">
          {activeCanned === 'Private'
            ? 'Only you will have access to this canned response.'
            : 'All group members will have access to this canned response.'}
        </p>

        <div className="Caneed-responseInput-Container">
          <p className="chat-txt">Response text</p>
          <TextArea
            className="canned-Input"
            value={responseText}
            rows={3}
            onChange={(e) => setResponseText(e.target.value)}
          />
          <br />
          <br />
          <Input
            title="Shortcuts"
            placeholder="# Type"
            value={tag}
            onChange={handleTagChange}
          />
        </div>

        <div className="PopUp-Canned-footer">
          <div className="PopUpCanned-button">
            <button className="Canned-Cancel" type="button" onClick={() => setCannedResponse(false)}>
              Cancel
            </button>

            <button
              className={`Canned-Save ${loading ? 'loading' : ''}`} // ✅ add loading class
              type="button"
              onClick={handleCreateCannedMsg}
              disabled={isSaveDisabled || loading} // ✅ disable during loading
            >
              {loading ? 'Saving...' : 'Save'} {/* ✅ text change */}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CannedPopup;
